import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUcusForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUcusForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  UcusKaydet: any;
  UcusKaydet_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  MasrafKaydet: any;
  MasrafKaydet_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  Confirmation: boolean;
  Confirmation_dummy: boolean;
  UcusGetir: any[];
  UcusGetir_dummy: any[];
  GetYetki: any;
  GetYetki_dummy: any;
  YeniGuid: any[];
  YeniGuid_dummy: any[];
  OnayDurumListe: any[];
  OnayDurumListe_dummy: any[];
  SirketSelectAll: any[];
  SirketSelectAll_dummy: any[];
  MurettebatListe: any[];
  MurettebatListe_dummy: any[];
  MasrafDurumListe: any[];
  MasrafDurumListe_dummy: any[];
  UcakListe: any[];
  UcakListe_dummy: any[];
  UlkeListe: any[];
  UlkeListe_dummy: any[];
  UcusTipiListe2: any[];
  UcusTipiListe2_dummy: any[];
  MasrafCesidiSelectAll: any[];
  MasrafCesidiSelectAll_dummy: any[];
  YolcuTmpYarat: number;
  YolcuTmpYarat_dummy: number;
  MasrafTmpYarat: number;
  MasrafTmpYarat_dummy: number;
  YolcuTmpListe: any[];
  YolcuTmpListe_dummy: any[];
  MasrafTmpListe: any[];
  MasrafTmpListe_dummy: any[];
  YazismaGetir: any[];
  YazismaGetir_dummy: any[];
  UcusGorunumAyarla: any;
  UcusGorunumAyarla_dummy: any;
  UcusuYapilmisRezervasyonKontrol: any;
  UcusuYapilmisRezervasyonKontrol_dummy: any;
  RezervasyonGetirByNo: any[];
  RezervasyonGetirByNo_dummy: any[];
  NoktaListe: any[];
  NoktaListe_dummy: any[];
  VarisNoktaListe: any[];
  VarisNoktaListe_dummy: any[];
  YolcuTmpAdet: any[];
  YolcuTmpAdet_dummy: any[];
  YolcuTmpAdSoyadlar: any[];
  YolcuTmpAdSoyadlar_dummy: any[];
  YolcuTmpSil: number;
  YolcuTmpSil_dummy: number;
  SplitStringBaknet: any[];
  SplitStringBaknet_dummy: any[];
  MasrafTmpToplamGuncelle: number;
  MasrafTmpToplamGuncelle_dummy: number;
  MasrafTmpSil: number;
  MasrafTmpSil_dummy: number;
  YazismaEkle: string;
  YazismaEkle_dummy: string;
  isComp162835Visible: "visible" | "hidden";
  isComp796340Visible: "visible" | "hidden";
  isComp46886Visible: "visible" | "hidden";
  isComp845903Visible: "visible" | "hidden";
  isComp388008Visible: "visible" | "hidden";
  isComp236180Visible: "visible" | "hidden";
  isComp855300Visible: "visible" | "hidden";
  isComp175518Visible: "visible" | "hidden";
  isComp972475Visible: "visible" | "hidden";
  isComp649358Visible: "visible" | "hidden";
  isComp808539Visible: "visible" | "hidden";
  isComp385661Visible: "visible" | "hidden";
  isComp249814Visible: "visible" | "hidden";
  isComp24225Visible: "visible" | "hidden";
  isComp949529Visible: "visible" | "hidden";
  isComp422516Visible: "visible" | "hidden";
  isComp506865Visible: "visible" | "hidden";
  isComp25952Visible: "visible" | "hidden";
  isComp845921Visible: "visible" | "hidden";
  isComp49457Visible: "visible" | "hidden";
  isComp575039Visible: "visible" | "hidden";
  isComp641052Visible: "visible" | "hidden";
  isComp115207Visible: "visible" | "hidden";
  isComp861472Visible: "visible" | "hidden";
  isComp252521Visible: "visible" | "hidden";
  isComp629348Visible: "visible" | "hidden";
  isComp884140Visible: "visible" | "hidden";
  isComp203119Visible: "visible" | "hidden";
  isComp848871Visible: "visible" | "hidden";
  isComp808818Visible: "visible" | "hidden";
  isComp354518Visible: "visible" | "hidden";
  isComp154338Enabled: "enabled" | "disabled";
  isComp510322Enabled: "enabled" | "disabled";
  isComp341783Enabled: "enabled" | "disabled";
  isComp956539Enabled: "enabled" | "disabled";
  isComp380974Enabled: "enabled" | "disabled";
  isComp825552Enabled: "enabled" | "disabled";
  isComp289033Enabled: "enabled" | "disabled";
  isComp227059Enabled: "enabled" | "disabled";
  isComp845007Enabled: "enabled" | "disabled";
  isComp403791Enabled: "enabled" | "disabled";
  isComp928204Enabled: "enabled" | "disabled";
  isComp167272Enabled: "enabled" | "disabled";
  isComp954041Enabled: "enabled" | "disabled";
  isComp900752Enabled: "enabled" | "disabled";
  isComp995117Enabled: "enabled" | "disabled";
  isComp771172Enabled: "enabled" | "disabled";
  isCompucusform_236180AuthorizationVisible: "visible" | "hidden";
  isCompucusform_855300AuthorizationVisible: "visible" | "hidden";
}

export class UcusForm_ScreenBase extends React.PureComponent<
  IUcusForm_ScreenProps,
  any
> {
  ucusform_942023_value_kuikaSelectBoxRef: React.RefObject<any>;
  ucusform_167735_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ucusform_459685_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ucusform_284227_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ucusform_554090_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ucusform_24259_value_kuikaDatetimeRef: React.RefObject<any>;
  ucusform_348523_value_kuikaDatetimeRef: React.RefObject<any>;
  ucusform_990298_value_kuikaTableRef: React.RefObject<any>;
  ucusform_13544_value_kuikaSelectBoxRef: React.RefObject<any>;
  ucusform_995117_value_kuikaSelectBoxRef: React.RefObject<any>;
  ucusform_524862_value_kuikaTableRef: React.RefObject<any>;
  ucusform_412266_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "81aa9116-d58d-418c-988b-7be7d16a8352",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 854746, PropertyName: "label", Value: "Vazgeç" },
        { Id: 162835, PropertyName: "label", Value: "Kaydet" },
        { Id: 796340, PropertyName: "label", Value: "Masraf C" },
        { Id: 46886, PropertyName: "label", Value: "Masraf Kaydet" },
        { Id: 845903, PropertyName: "label", Value: "Masraf Tamamla" },
        { Id: 388008, PropertyName: "label", Value: "Onayla" },
        { Id: 236180, PropertyName: "label", Value: "Masraf Onayla" },
        { Id: 855300, PropertyName: "label", Value: "Masraf Reddet" },
        { Id: 175518, PropertyName: "label", Value: "Sil" },
        { Id: 972475, PropertyName: "value", Value: "Uçuş Kaydı" },
        {
          Id: 649358,
          PropertyName: "value",
          Value: "Uçuş Kaydı - Masraf Girişi",
        },
        { Id: 808539, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 385661, PropertyName: "label", Value: "Yolcu" },
        { Id: 249814, PropertyName: "label", Value: "Pilot" },
        { Id: 24225, PropertyName: "label", Value: "Yönetici Asistanı" },
        { Id: 949529, PropertyName: "label", Value: "Ucuş Müdürü" },
        { Id: 422516, PropertyName: "label", Value: "Teknisyen" },
        { Id: 506865, PropertyName: "placeholder", Value: "User Role Names" },
        { Id: 25952, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 845921, PropertyName: "label", Value: "Tarihçe" },
        { Id: 860329, PropertyName: "value", Value: "Uçuş No" },
        {
          Id: 510322,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 49457, PropertyName: "label", Value: "Silindi" },
        { Id: 70519, PropertyName: "value", Value: "Onay Durumu" },
        { Id: 956539, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 907296, PropertyName: "value", Value: "Rezervasyon No" },
        { Id: 825552, PropertyName: "placeholder", Value: "0" },
        { Id: 7557, PropertyName: "value", Value: "Uçuş Tipi" },
        { Id: 942023, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 969375, PropertyName: "value", Value: "Kalkış Noktası" },
        { Id: 167735, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 459685, PropertyName: "placeholder", Value: "Search..." },
        { Id: 520444, PropertyName: "value", Value: "Varış Noktası" },
        { Id: 284227, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 554090, PropertyName: "placeholder", Value: "Search..." },
        { Id: 497421, PropertyName: "value", Value: "Motor Çalıştırma" },
        {
          Id: 24259,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 617128, PropertyName: "value", Value: "Motor Susturma" },
        {
          Id: 348523,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 585990, PropertyName: "value", Value: "İniş Taco" },
        { Id: 991673, PropertyName: "value", Value: "Son Taco" },
        { Id: 838670, PropertyName: "value", Value: "Yolcular" },
        { Id: 575039, PropertyName: "placeholder", Value: "33.45" },
        { Id: 641052, PropertyName: "label", Value: "Ekle" },
        {
          Id: 990298,
          PropertyName: "nodatafoundmessage",
          Value: "Henüz yolcu yok...",
        },
        { Id: 489617, PropertyName: "title", Value: "Kayıtlı/Kayıtsız" },
        { Id: 115207, PropertyName: "value", Value: "Kayıtlı" },
        { Id: 861472, PropertyName: "value", Value: "Kayıtsız" },
        { Id: 937170, PropertyName: "title", Value: "Ad Soyad" },
        { Id: 707202, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 128889, PropertyName: "title", Value: "Ağılık (Kg)" },
        { Id: 370804, PropertyName: "value", Value: "[datafield:agirlik]" },
        { Id: 474346, PropertyName: "title", Value: "Bagaj Adet" },
        { Id: 292751, PropertyName: "value", Value: "[datafield:bagajadet]" },
        { Id: 382877, PropertyName: "title", Value: "Bagaj Ağırlık (Kg)" },
        {
          Id: 625246,
          PropertyName: "value",
          Value: "[datafield:bagajagirlik]",
        },
        { Id: 252521, PropertyName: "title", Value: "İşlem" },
        { Id: 186862, PropertyName: "value", Value: "Müşteri Şirketler" },
        { Id: 143451, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 385903, PropertyName: "value", Value: "Müretebat" },
        { Id: 316139, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 347625, PropertyName: "value", Value: "Sorumlu Pilot" },
        {
          Id: 13544,
          PropertyName: "placeholder",
          Value: "Önce mürettebat seçiniz... ",
        },
        { Id: 752142, PropertyName: "value", Value: "Masraf Çeşitleri" },
        { Id: 835559, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 450485, PropertyName: "value", Value: "Masraf Durumu" },
        { Id: 995117, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 204870, PropertyName: "value", Value: "Masraf Onaylayan" },
        { Id: 771172, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 639952, PropertyName: "value", Value: "Masraflar" },
        { Id: 629348, PropertyName: "label", Value: "Ekle" },
        {
          Id: 524862,
          PropertyName: "nodatafoundmessage",
          Value: "Henüz masraf yok...",
        },
        { Id: 927090, PropertyName: "title", Value: "Sıra No" },
        { Id: 599348, PropertyName: "value", Value: "[datafield:sirano]" },
        { Id: 147891, PropertyName: "title", Value: "Şirketler" },
        { Id: 875348, PropertyName: "value", Value: "[datafield:sirketler]" },
        { Id: 813134, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 36151, PropertyName: "title", Value: "Masraf Kodu" },
        { Id: 149408, PropertyName: "value", Value: "[datafield:masrafkodu]" },
        { Id: 988667, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 31091, PropertyName: "title", Value: "Masraf Çeşidi" },
        {
          Id: 698848,
          PropertyName: "value",
          Value: "[datafield:masrafcesidi]",
        },
        { Id: 652004, PropertyName: "title", Value: "Tutar" },
        { Id: 521220, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 681735, PropertyName: "placeholder", Value: "15" },
        { Id: 341262, PropertyName: "title", Value: "P.Br." },
        { Id: 436727, PropertyName: "value", Value: "[datafield:pbr]" },
        { Id: 41634, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 37639, PropertyName: "title", Value: "Açıklama" },
        { Id: 119928, PropertyName: "value", Value: "[datafield:aciklama]" },
        { Id: 318005, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 575369, PropertyName: "title", Value: "Dosyalar" },
        { Id: 967293, PropertyName: "value", Value: "[datafield:dosyaad1]" },
        { Id: 309815, PropertyName: "value", Value: "[datafield:dosyaad2]" },
        { Id: 930625, PropertyName: "value", Value: "[datafield:dosyaad3]" },
        { Id: 884140, PropertyName: "title", Value: "İşlem" },
        { Id: 308589, PropertyName: "value", Value: "Yazışma" },
        {
          Id: 412266,
          PropertyName: "nodatafoundmessage",
          Value: "Henüz yolcu yok...",
        },
        { Id: 777940, PropertyName: "title", Value: "Yazışma" },
        { Id: 296137, PropertyName: "value", Value: "[datafield:metin]" },
        { Id: 565085, PropertyName: "value", Value: "[datafield:talepeden]" },
        {
          Id: 987221,
          PropertyName: "value",
          Value: "[datafield:talepedenzaman]",
        },
        { Id: 54829, PropertyName: "value", Value: "[datafield:metin]" },
        {
          Id: 487355,
          PropertyName: "value",
          Value: "[datafield:onaylayanzaman]",
        },
        { Id: 132389, PropertyName: "value", Value: "[datafield:onaylayan]" },
        {
          Id: 755702,
          PropertyName: "placeholder",
          Value: "Bir mesaj yazın ...",
        },
        { Id: 631587, PropertyName: "label", Value: "Gönder" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.ucusform_808539_value_kuikaTextInputRef = React.createRef();
    this.ucusform_506865_value_kuikaTextInputRef = React.createRef();
    this.ucusform_25952_value_kuikaTextInputRef = React.createRef();
    this.ucusform_510322_value_kuikaTextInputRef = React.createRef();
    this.ucusform_956539_value_kuikaTextInputRef = React.createRef();
    this.ucusform_942023_value_kuikaSelectBoxRef = React.createRef();
    this.ucusform_167735_value_kuikaAutoCompleteRef = React.createRef();
    this.ucusform_459685_value_kuikaAutoCompleteRef = React.createRef();
    this.ucusform_284227_value_kuikaAutoCompleteRef = React.createRef();
    this.ucusform_554090_value_kuikaAutoCompleteRef = React.createRef();
    this.ucusform_24259_value_kuikaDatetimeRef = React.createRef();
    this.ucusform_348523_value_kuikaDatetimeRef = React.createRef();
    this.ucusform_990298_value_kuikaTableRef = React.createRef();
    this.ucusform_13544_value_kuikaSelectBoxRef = React.createRef();
    this.ucusform_995117_value_kuikaSelectBoxRef = React.createRef();
    this.ucusform_771172_value_kuikaTextInputRef = React.createRef();
    this.ucusform_524862_value_kuikaTableRef = React.createRef();
    this.ucusform_813134_value_kuikaTextInputRef = React.createRef();
    this.ucusform_988667_value_kuikaTextInputRef = React.createRef();
    this.ucusform_41634_value_kuikaTextInputRef = React.createRef();
    this.ucusform_318005_value_kuikaTextInputRef = React.createRef();
    this.ucusform_412266_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      UcusKaydet: "",
      NAVIGATE: "",
      IfThenElse: false,
      MasrafKaydet: "",
      SetValueOf: "",
      TriggerEvent: "",
      Confirmation: false,
      UcusGetir: [],
      GetYetki: "",
      YeniGuid: [],
      OnayDurumListe: [],
      SirketSelectAll: [],
      MurettebatListe: [],
      MasrafDurumListe: [],
      UcakListe: [],
      UlkeListe: [],
      UcusTipiListe2: [],
      MasrafCesidiSelectAll: [],
      YolcuTmpListe: [],
      MasrafTmpListe: [],
      YazismaGetir: [],
      UcusGorunumAyarla: "",
      UcusuYapilmisRezervasyonKontrol: "",
      RezervasyonGetirByNo: [],
      YolcuTmpYarat: 0,
      NoktaListe: [],
      VarisNoktaListe: [],
      YolcuTmpAdet: [],
      YolcuTmpAdSoyadlar: [],
      YolcuTmpSil: 0,
      SplitStringBaknet: [],
      MasrafTmpToplamGuncelle: 0,
      MasrafTmpSil: 0,
      YazismaEkle: "",
      isComp162835Visible: "hidden",
      isComp796340Visible: "hidden",
      isComp46886Visible: "hidden",
      isComp845903Visible: "hidden",
      isComp388008Visible: "hidden",
      isComp236180Visible: "hidden",
      isComp855300Visible: "hidden",
      isComp175518Visible: "hidden",
      isComp972475Visible: "hidden",
      isComp649358Visible: "hidden",
      isComp808539Visible: "hidden",
      isComp385661Visible: "hidden",
      isComp249814Visible: "hidden",
      isComp24225Visible: "hidden",
      isComp949529Visible: "hidden",
      isComp422516Visible: "hidden",
      isComp506865Visible: "hidden",
      isComp25952Visible: "hidden",
      isComp845921Visible: "hidden",
      isComp49457Visible: "hidden",
      isComp575039Visible: "hidden",
      isComp641052Visible: "hidden",
      isComp115207Visible: "hidden",
      isComp861472Visible: "hidden",
      isComp252521Visible: "hidden",
      isComp629348Visible: "hidden",
      isComp884140Visible: "hidden",
      isComp203119Visible: "hidden",
      isComp848871Visible: "hidden",
      isComp808818Visible: "hidden",
      isComp354518Visible: "hidden",
      isComp154338Enabled: "disabled",
      isComp510322Enabled: "disabled",
      isComp341783Enabled: "disabled",
      isComp956539Enabled: "disabled",
      isComp380974Enabled: "disabled",
      isComp825552Enabled: "disabled",
      isComp289033Enabled: "disabled",
      isComp227059Enabled: "disabled",
      isComp845007Enabled: "disabled",
      isComp403791Enabled: "disabled",
      isComp928204Enabled: "disabled",
      isComp167272Enabled: "disabled",
      isComp954041Enabled: "disabled",
      isComp900752Enabled: "disabled",
      isComp995117Enabled: "disabled",
      isComp771172Enabled: "disabled",
      isCompucusform_236180AuthorizationVisible: "visible",
      isCompucusform_855300AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ucusform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UcusFormPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompucusform_236180AuthorizationVisible",
      ["e1393ac7-79a1-8995-202f-8c208b60d9b6", "FLYMALIISLER"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompucusform_855300AuthorizationVisible",
      ["e1393ac7-79a1-8995-202f-8c208b60d9b6", "FLYMALIISLER"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("ucusform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYASISTAN",
      "FLYPILOT",
      "FLYMALIISLER",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ucusform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UcusFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      ucusform_385661_checked: this.state.GetYetki?.yolcu ?? undefined,
      ucusform_249814_checked: this.state.GetYetki?.pilot ?? undefined,
      ucusform_24225_checked: this.state.GetYetki?.asistan ?? undefined,
      ucusform_949529_checked: this.state.GetYetki?.mudur ?? undefined,
      ucusform_422516_checked: this.state.GetYetki?.teknisyen ?? undefined,
      ucusform_49457_checked: false,
      ucusform_341783_value: false,
      ucusform_825552_value: undefined,
      ucusform_361964_value: undefined,
      ucusform_403791_value: undefined,
      ucusform_575039_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UcusFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_506865_value",
        "string"
      ),
      ReactSystemFunctions.getMyRoleNames(),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      yetkiStr_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_506865_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UcusGetir = result?.data.ucusGetir;
    stateVars.isComp49457Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGetir !== undefined
            ? stateVars.UcusGetir?.length > 0
              ? stateVars.UcusGetir[0].silindi
              : null
            : this.state.UcusGetir?.length > 0
            ? this.state.UcusGetir[0].silindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetYetki = result?.data.getYetki;
    formVars.ucusform_385661_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.yolcu
    );
    formVars.ucusform_249814_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.pilot
    );
    formVars.ucusform_24225_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.asistan
    );
    formVars.ucusform_949529_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.mudur
    );
    formVars.ucusform_422516_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.teknisyen
    );
    stateVars.YeniGuid = result?.data.yeniGuid;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_808539_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.YeniGuid !== undefined
          ? stateVars.YeniGuid?.length > 0
            ? stateVars.YeniGuid[0].newguid
            : null
          : this.state.YeniGuid?.length > 0
          ? this.state.YeniGuid[0].newguid
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OnayDurumListe = result?.data.onayDurumListe;
    stateVars.SirketSelectAll = result?.data.sirketSelectAll;

    formVars.ucusform_143451_options = stateVars.SirketSelectAll;
    stateVars.MurettebatListe = result?.data.murettebatListe;

    formVars.ucusform_316139_options = stateVars.MurettebatListe;
    stateVars.MasrafDurumListe = result?.data.masrafDurumListe;

    formVars.ucusform_995117_options = stateVars.MasrafDurumListe;
    stateVars.UcakListe = result?.data.ucakListe;
    stateVars.UlkeListe = result?.data.ulkeListe;

    formVars.ucusform_167735_options = stateVars.UlkeListe;

    formVars.ucusform_284227_options = stateVars.UlkeListe;
    stateVars.UcusTipiListe2 = result?.data.ucusTipiListe2;

    formVars.ucusform_942023_options = stateVars.UcusTipiListe2;
    stateVars.MasrafCesidiSelectAll = result?.data.masrafCesidiSelectAll;

    formVars.ucusform_835559_options = stateVars.MasrafCesidiSelectAll;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormPageInit_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_510322_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].ucusNo
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].ucusNo
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_942023_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].ucusTipi
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].ucusTipi
          : null
      ),
      null,
      "Kod"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if41_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if41_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_167735_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].kalkisUlke
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].kalkisUlke
          : null
      ),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.UcusFormComponent_167735_onChange) {
      {
        await this.UcusFormComponent_167735_onChange();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if42_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if42_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_459685_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].kalkisNokta
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].kalkisNokta
          : null
      ),
      null,
      "icaoCode"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if43_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if43_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_284227_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].varisUlke
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].varisUlke
          : null
      ),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.UcusFormComponent_284227_onChange) {
      {
        await this.UcusFormComponent_284227_onChange();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if44_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if44_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_554090_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].varisNokta
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].varisNokta
          : null
      ),
      null,
      "icaoCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_316139_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].murettebat
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].murettebat
          : null
      ),
      null,
      true
    );

    if (stateVars.SetValueOf && this.UcusFormComponent_316139_onChange) {
      {
        await this.UcusFormComponent_316139_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_13544_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].pilot
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].pilot
          : null
      ),
      null,
      "Str"
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if45_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if45_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "ucusform_575039_value",
          "value",
          "",
          "",
          ""
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_825552_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].rezervasyonNo
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].rezervasyonNo
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if46_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if46_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      GrupId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormPageInit_if46_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpYarat = result?.data.yolcuTmpYarat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if47_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormPageInit_if47_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_835559_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].masrafCesitleri
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].masrafCesitleri
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_341783_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].onayDurumu
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].onayDurumu
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_956539_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].onaylayan
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].onaylayan
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_361964_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].toLanding
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].toLanding
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_403791_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].sonTaco
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].sonTaco
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if48_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if48_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      UcusNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_510322_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormPageInit_if48_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafTmpYarat = result?.data.masrafTmpYarat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if49_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormPageInit_if49_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_143451_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].sirketler
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].sirketler
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_995117_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].masrafDurum
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].masrafDurum
          : null
      ),
      null,
      "Durum"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_771172_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].masrafOnaylayan
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].masrafOnaylayan
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_24259_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].motorCalistirma
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].motorCalistirma
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_348523_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].motorSusturma
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].motorSusturma
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_49457_checked",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcusGetir !== undefined
          ? stateVars.UcusGetir?.length > 0
            ? stateVars.UcusGetir[0].silindi
            : null
          : this.state.UcusGetir?.length > 0
          ? this.state.UcusGetir[0].silindi
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UcusFormPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "2"
      ) ||
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "1"
      )
    ) {
      isErrorOccurred = await this.UcusFormPageInit_if4();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if5 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit_if51_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit_if51_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isGreaterThan(
        this.props.screenInputs.RezervasyonNo ??
          this.props.screenInputs.rezervasyonno,
        "0"
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "ucusform_825552_value",
          "string"
        ),
        this.props.screenInputs.RezervasyonNo ??
          this.props.screenInputs.rezervasyonno,
        null,
        true
      );

      if (stateVars.SetValueOf && this.UcusFormComponent_825552_onPressEnter) {
        {
          await this.UcusFormComponent_825552_onPressEnter();
        }
      }

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormPageInit_if52_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormPageInit_if52_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormPageInit_if52_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_403791_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.UcakListe !== undefined
          ? stateVars.UcakListe?.length > 0
            ? stateVars.UcakListe[0].sonTaco
            : null
          : this.state.UcakListe?.length > 0
          ? this.state.UcakListe[0].sonTaco
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_995117_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Durum"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UcusFormPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      )
    ) {
      isErrorOccurred = await this.UcusFormPageInit_if5();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit6_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      RezervasyonId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      UserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      UcusId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      CrudMode_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "number"
      ),
      MasrafMode_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        "boolean"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormPageInit6_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    stateVars.MasrafTmpListe = result?.data.masrafTmpListe;

    stateVars.YazismaGetir = result?.data.yazismaGetir;

    stateVars.UcusGorunumAyarla = result?.data.ucusGorunumAyarla;
    stateVars.isComp162835Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.ucusDegistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp46886Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.masrafDegistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp845903Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.masrafTamamla
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp388008Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.UcusGorunumAyarla?.ucusOnay),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236180Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.masrafOnay
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp855300Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.masrafRed
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp175518Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.UcusGorunumAyarla?.ucusSil),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp641052Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.ucusDegistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp252521Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.ucusDegistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp629348Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.masrafDegistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp884140Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGorunumAyarla?.masrafDegistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.value(
            this,
            "ucusform_524862_value",
            "masrafKodu"
          ),
          ReactSystemFunctions.convertToTypeByName("TOPLAM", "string")
        )) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormPageInit7_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormPageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        true
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "ucusform_25952_value",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("M", "string"),
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormPageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormPageInit8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormPageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp162835Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.ucusDegistir
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp46886Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.masrafDegistir
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp845903Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.masrafTamamla
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp388008Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.ucusOnay
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp236180Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.masrafOnay
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp855300Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.masrafRed
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp175518Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.UcusGorunumAyarla?.ucusSil),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp972475Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp649358Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.ucusform_385661_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.yolcu
    );

    formVars.ucusform_249814_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.pilot
    );

    formVars.ucusform_24225_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.asistan
    );

    formVars.ucusform_949529_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.mudur
    );

    formVars.ucusform_422516_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.teknisyen
    );

    stateVars.isComp845921Visible =
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp154338Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp49457Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGetir !== undefined
            ? stateVars.UcusGetir?.length > 0
              ? stateVars.UcusGetir[0].silindi
              : null
            : this.state.UcusGetir?.length > 0
            ? this.state.UcusGetir[0].silindi
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp380974Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_942023 =
      stateVars.UcusTipiListe2 ?? this.state.UcusTipiListe2;
    stateVars.dataSource_942023 =
      stateVars.UcusTipiListe2 ?? this.state.UcusTipiListe2;
    stateVars.isComp289033Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_167735 = stateVars.UlkeListe ?? this.state.UlkeListe;
    stateVars.dataSource_167735 = stateVars.UlkeListe ?? this.state.UlkeListe;

    stateVars.dataSource_284227 = stateVars.UlkeListe ?? this.state.UlkeListe;
    stateVars.dataSource_284227 = stateVars.UlkeListe ?? this.state.UlkeListe;
    stateVars.isComp227059Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp845007Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp641052Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.ucusDegistir
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;
    stateVars.isComp115207Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "ucusform_990298_value", "isManuel"),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp861472Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "ucusform_990298_value", "isManuel"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp252521Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.ucusDegistir
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp928204Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_143451 =
      stateVars.SirketSelectAll ?? this.state.SirketSelectAll;
    stateVars.dataSource_143451 =
      stateVars.SirketSelectAll ?? this.state.SirketSelectAll;
    stateVars.isComp167272Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_316139 =
      stateVars.MurettebatListe ?? this.state.MurettebatListe;
    stateVars.dataSource_316139 =
      stateVars.MurettebatListe ?? this.state.MurettebatListe;
    stateVars.isComp954041Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp900752Enabled =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.MasrafMode ??
          this.props.screenInputs.masrafmode,
        false
      ) === true
        ? "enabled"
        : "disabled";

    stateVars.dataSource_835559 =
      stateVars.MasrafCesidiSelectAll ?? this.state.MasrafCesidiSelectAll;
    stateVars.dataSource_835559 =
      stateVars.MasrafCesidiSelectAll ?? this.state.MasrafCesidiSelectAll;

    stateVars.dataSource_995117 =
      stateVars.MasrafDurumListe ?? this.state.MasrafDurumListe;
    stateVars.dataSource_995117 =
      stateVars.MasrafDurumListe ?? this.state.MasrafDurumListe;
    stateVars.isComp629348Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.masrafDegistir
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_524862 =
      stateVars.MasrafTmpListe ?? this.state.MasrafTmpListe;
    stateVars.isComp884140Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusGorunumAyarla?.masrafDegistir
        ),
        true
      ) &&
        ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.value(
            this,
            "ucusform_524862_value",
            "masrafKodu"
          ),
          "TOPLAM"
        )) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_412266 =
      stateVars.YazismaGetir ?? this.state.YazismaGetir;
    stateVars.isComp203119Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "ucusform_412266_value", "isYolcu"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848871Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "ucusform_412266_value", "isYolcu"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp808818Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "ucusform_412266_value", "isYolcu"),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp354518Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "ucusform_412266_value", "isYolcu"),
        false
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UcusFormComponent_854746_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_162835_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      UcusId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      KalkisUlke_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_167735_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      KalkisNokta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_459685_value",
            "value",
            "NoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        "string"
      ),
      MasrafCesitleri_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_835559_value",
            "value",
            "MasrafCesidiSelectAll",
            "kod",
            "kod"
          )
        ),
        "string"
      ),
      MotorCalistirma_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_24259_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      MotorSusturma_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_348523_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Murettebat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_316139_value",
            "value",
            "MurettebatListe",
            "adSoyad",
            "adSoyad"
          )
        ),
        "string"
      ),
      OnayDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_341783_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      Onaylayan_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_956539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Pilot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_13544_value",
            "value",
            "SplitStringBaknet",
            "str",
            "str"
          )
        ),
        "string"
      ),
      RezervasyonNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Sirketler_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_143451_value",
            "value",
            "SirketSelectAll",
            "sirket",
            "sirket"
          )
        ),
        "string"
      ),
      ToLanding_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_361964_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Ucak_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UcakListe !== undefined
            ? stateVars.UcakListe?.length > 0
              ? stateVars.UcakListe[0].ad
              : null
            : this.state.UcakListe?.length > 0
            ? this.state.UcakListe[0].ad
            : null
        ),
        "string"
      ),
      UcusTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_942023_value",
            "value",
            "UcusTipiListe2",
            "kod",
            "kod"
          )
        ),
        "number"
      ),
      VarisUlke_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_284227_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      VarisNokta_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_554090_value",
            "value",
            "VarisNoktaListe",
            "icaoCode",
            "icaoCode"
          )
        ),
        "string"
      ),
      Silindi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_49457_checked",
            "checked",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_162835_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UcusKaydet = result?.data.ucusKaydet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_162835_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_162835_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.UcusKaydet?.durum),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(this, this.state.UcusKaydet?.mesaj),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.convertToTypeByName("Hata", "string"),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(1, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.UcusFormComponent_162835_onClick2_,
        "UcusForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "166670",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormComponent_162835_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormComponent_162835_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.UcusKaydet?.durum),
        "1"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(this, this.state.UcusKaydet?.mesaj),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName("Uyarı", "string")
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(2, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.UcusFormComponent_162835_onClick3_,
        "UcusForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "909141",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormComponent_162835_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormComponent_162835_onClick_if3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.UcusKaydet?.mesaj),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName("Bilgi", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_162835_onClick_if31_,
      "UcusForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "817067",
      null,
      null,
      "true",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_162835_onClick_if31_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.UcusFormComponent_854746_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UcusFormComponent_162835_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.UcusKaydet?.durum),
        "0"
      )
    ) {
      isErrorOccurred = await this.UcusFormComponent_162835_onClick_if3();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_796340_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      UcusId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      MasrafDurum_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_995117_value",
            "value",
            "MasrafDurumListe",
            "durum",
            "durum"
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_796340_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafKaydet = result?.data.masrafKaydet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_796340_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_796340_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.MasrafKaydet?.durum),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(this, this.state.MasrafKaydet?.mesaj),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.convertToTypeByName("Hata", "string"),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(1, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.UcusFormComponent_796340_onClick2_,
        "UcusForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "608600",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormComponent_796340_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormComponent_796340_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.MasrafKaydet?.durum),
        "1"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(this, this.state.MasrafKaydet?.mesaj),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName("Uyarı", "string")
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(2, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.UcusFormComponent_796340_onClick3_,
        "UcusForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "313635",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormComponent_796340_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormComponent_796340_onClick_if3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.MasrafKaydet?.mesaj),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName("Bilgi", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_796340_onClick_if31_,
      "UcusForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "817067",
      null,
      null,
      "true",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_796340_onClick_if31_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.UcusFormComponent_854746_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UcusFormComponent_796340_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.MasrafKaydet?.durum),
        "0"
      )
    ) {
      isErrorOccurred = await this.UcusFormComponent_796340_onClick_if3();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_46886_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_995117_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("1", "string"),
      null,
      "Durum"
    );
    if (await this.UcusFormComponent_796340_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_845903_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_995117_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("2", "string"),
      null,
      "Durum"
    );
    if (await this.UcusFormComponent_796340_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_388008_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_341783_value",
        "string"
      ),
      true,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_956539_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      false
    );
    if (await this.UcusFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_236180_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_995117_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Durum"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_771172_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      false
    );
    if (await this.UcusFormComponent_796340_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_855300_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_995117_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("4", "string"),
      null,
      "Durum"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_771172_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      false
    );
    if (await this.UcusFormComponent_796340_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_175518_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Confirmation = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4d5a204f_61be_eda1_21c1_50992a766781_confirmation_action",
        this.defaultML,
        ReactSystemFunctions.convertToTypeByName(
          "Uçuş kaydını silmek istediğinize emin misiniz?",
          "string"
        )
      ),
      ReactSystemFunctions.convertToTypeByName("Poppins", "string"),
      ReactSystemFunctions.convertToTypeByName("UYARI", "string"),
      ReactSystemFunctions.convertToTypeByName("trash", "string"),
      ReactSystemFunctions.convertToTypeByName("#ff2424", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_175518_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormComponent_175518_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_49457_checked",
        "string"
      ),
      true,
      null,
      false
    );
    if (await this.UcusFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UcusFormComponent_175518_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        true
      )
    ) {
      isErrorOccurred = await this.UcusFormComponent_175518_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_899034_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusForm",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "352231",
      null,
      "left",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_845921_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterTablo",
      ReactSystemFunctions.convertToTypeByName("Fly.Ucus", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Ekleyen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UcusGetir !== undefined
            ? stateVars.UcusGetir?.length > 0
              ? stateVars.UcusGetir[0].ekleyen
              : null
            : this.state.UcusGetir?.length > 0
            ? this.state.UcusGetir[0].ekleyen
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Degistiren",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UcusGetir !== undefined
            ? stateVars.UcusGetir?.length > 0
              ? stateVars.UcusGetir[0].degistiren
              : null
            : this.state.UcusGetir?.length > 0
            ? this.state.UcusGetir[0].degistiren
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "EklemeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGetir !== undefined
            ? stateVars.UcusGetir?.length > 0
              ? stateVars.UcusGetir[0].eklemeZamani
              : null
            : this.state.UcusGetir?.length > 0
            ? this.state.UcusGetir[0].eklemeZamani
            : null
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "DegistitirmeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.UcusGetir !== undefined
            ? stateVars.UcusGetir?.length > 0
              ? stateVars.UcusGetir[0].degistirmeZamani
              : null
            : this.state.UcusGetir?.length > 0
            ? this.state.UcusGetir[0].degistirmeZamani
            : null
        ),
        "Date"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusForm",
      "TarihceList",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "288527",
      null,
      "right",
      "False",
      "100vw",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_825552_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UcusId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      RezervasyonNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_825552_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UcusuYapilmisRezervasyonKontrol =
      result?.data.ucusuYapilmisRezervasyonKontrol;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_825552_value",
        "string"
      ),
      null,
      null,
      false
    );
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.UcusuYapilmisRezervasyonKontrol?.mesaj
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName("Uyarı", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_825552_onPressEnter_if11_,
      "UcusForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "139274",
      null,
      null,
      "true",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, "");

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UcusFormComponent_825552_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.UcusuYapilmisRezervasyonKontrol?.durum
        ),
        "0"
      )
    ) {
      isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RezervasyonNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_825552_onPressEnter2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RezervasyonGetirByNo = result?.data.rezervasyonGetirByNo;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGetirByNo !== undefined
            ? stateVars.RezervasyonGetirByNo?.length > 0
              ? stateVars.RezervasyonGetirByNo[0].id
              : null
            : this.state.RezervasyonGetirByNo?.length > 0
            ? this.state.RezervasyonGetirByNo[0].id
            : null
        ),
        true
      ) &&
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_825552_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.convertToTypeByName(
            "Rezervasyon bulunamadı",
            "string"
          ),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.convertToTypeByName("Uyarı", "string"),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(2, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.UcusFormComponent_825552_onPressEnter4_,
        "UcusForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "48533",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.UcusFormComponent_825552_onPressEnter4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_942023_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].ucusTipiStr
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].ucusTipiStr
          : null
      ),
      null,
      "Kod"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_167735_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].kalkisUlke
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].kalkisUlke
          : null
      ),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.UcusFormComponent_167735_onChange) {
      {
        await this.UcusFormComponent_167735_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_459685_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].kalkisNokta
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].kalkisNokta
          : null
      ),
      null,
      "icaoCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_284227_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].varisUlke
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].varisUlke
          : null
      ),
      null,
      "code"
    );

    if (stateVars.SetValueOf && this.UcusFormComponent_284227_onChange) {
      {
        await this.UcusFormComponent_284227_onChange();
      }
    }
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_554090_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].varisNokta
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].varisNokta
          : null
      ),
      null,
      "icaoCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_24259_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].kalkisSaat
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].kalkisSaat
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_348523_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].varisSaat
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].varisSaat
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_316139_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.RezervasyonGetirByNo !== undefined
          ? stateVars.RezervasyonGetirByNo?.length > 0
            ? stateVars.RezervasyonGetirByNo[0].murettebat
            : null
          : this.state.RezervasyonGetirByNo?.length > 0
          ? this.state.RezervasyonGetirByNo[0].murettebat
          : null
      ),
      null,
      true
    );

    if (stateVars.SetValueOf && this.UcusFormComponent_316139_onChange) {
      {
        await this.UcusFormComponent_316139_onChange();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      GrupId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.RezervasyonGetirByNo !== undefined
            ? stateVars.RezervasyonGetirByNo?.length > 0
              ? stateVars.RezervasyonGetirByNo[0].id
              : null
            : this.state.RezervasyonGetirByNo?.length > 0
            ? this.state.RezervasyonGetirByNo[0].id
            : null
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_825552_onPressEnter5_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpYarat = result?.data.yolcuTmpYarat;
    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter6_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_825552_onPressEnter6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_167735_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_167735_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("%", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_167735_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NoktaListe = result?.data.noktaListe;

    formVars.ucusform_459685_options = stateVars.NoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_167735_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_167735_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;
    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_459685_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_167735_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_459685_value",
            "",
            "NoktaListe",
            "icaoCode",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_459685_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NoktaListe = result?.data.noktaListe;

    formVars.ucusform_459685_options = stateVars.NoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_459685_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_459685_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;
    stateVars.dataSource_459685 = stateVars.NoktaListe ?? this.state.NoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_284227_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_284227_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("%", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_284227_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.VarisNoktaListe = result?.data.varisNoktaListe;

    formVars.ucusform_554090_options = stateVars.VarisNoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_284227_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_284227_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;
    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_554090_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      country_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_284227_value",
            "value",
            "UlkeListe",
            "code",
            "code"
          )
        ),
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_554090_value",
            "",
            "VarisNoktaListe",
            "icaoCode",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_554090_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.VarisNoktaListe = result?.data.varisNoktaListe;

    formVars.ucusform_554090_options = stateVars.VarisNoktaListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_554090_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_554090_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;
    stateVars.dataSource_554090 =
      stateVars.VarisNoktaListe ?? this.state.VarisNoktaListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_641052_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "EditId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_641052_onClick1_,
      "UcusForm",
      "YolcuForm",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "595964",
      null,
      null,
      "False",
      "800px",
      "80vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_641052_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_641052_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    stateVars.YolcuTmpAdet = result?.data.yolcuTmpAdet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_641052_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_641052_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.YolcuTmpAdet !== undefined
          ? stateVars.YolcuTmpAdet?.length > 0
            ? stateVars.YolcuTmpAdet[0].adet
            : null
          : this.state.YolcuTmpAdet?.length > 0
          ? this.state.YolcuTmpAdet[0].adet
          : null
      ),
      null,
      false
    );

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_127384_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_990298_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YolcuForm",
      "EditId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_127384_onClick1_,
      "UcusForm",
      "YolcuForm",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "833334",
      null,
      null,
      "False",
      "800px",
      "80vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_127384_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_127384_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

    stateVars.YolcuTmpAdSoyadlar = result?.data.yolcuTmpAdSoyadlar;
    stateVars.YolcuTmpAdet = result?.data.yolcuTmpAdet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_127384_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_127384_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.YolcuTmpAdet !== undefined
          ? stateVars.YolcuTmpAdet?.length > 0
            ? stateVars.YolcuTmpAdet[0].adet
            : null
          : this.state.YolcuTmpAdet?.length > 0
          ? this.state.YolcuTmpAdet[0].adet
          : null
      ),
      null,
      false
    );

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_938114_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_990298_value", "id"),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f36f212e_8a4e_2148_7b55_dbb558cf4083_confirmation",
        this.defaultML,
        "Silmek istediğinize emin misiniz?"
      ),
      "poppins",
      "Uyarı",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "UcusForm/UcusFormComponent_938114_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YolcuTmpSil = result?.data.yolcuTmpSil;
      stateVars.YolcuTmpListe = result?.data.yolcuTmpListe;

      stateVars.YolcuTmpAdSoyadlar = result?.data.yolcuTmpAdSoyadlar;
      stateVars.YolcuTmpAdet = result?.data.yolcuTmpAdet;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormComponent_938114_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_938114_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_575039_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.YolcuTmpAdet !== undefined
          ? stateVars.YolcuTmpAdet?.length > 0
            ? stateVars.YolcuTmpAdet[0].adet
            : null
          : this.state.YolcuTmpAdet?.length > 0
          ? this.state.YolcuTmpAdet[0].adet
          : null
      ),
      null,
      false
    );

    stateVars.dataSource_990298 =
      stateVars.YolcuTmpListe ?? this.state.YolcuTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_316139_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      longStr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_316139_value",
            "value",
            "MurettebatListe",
            "adSoyad",
            "adSoyad"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_316139_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SplitStringBaknet = result?.data.splitStringBaknet;

    formVars.ucusform_13544_options = stateVars.SplitStringBaknet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_316139_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_316139_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_13544 =
      stateVars.SplitStringBaknet ?? this.state.SplitStringBaknet;
    stateVars.dataSource_13544 =
      stateVars.SplitStringBaknet ?? this.state.SplitStringBaknet;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_629348_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MasrafForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "MasrafForm",
      "EditId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MasrafForm",
      "UcusNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_510322_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_629348_onClick1_,
      "UcusForm",
      "MasrafForm",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "187396",
      null,
      null,
      "False",
      "800px",
      "70vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_629348_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_629348_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafTmpListe = result?.data.masrafTmpListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_629348_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_629348_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_524862 =
      stateVars.MasrafTmpListe ?? this.state.MasrafTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_967293_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "DosyaGoster",
      "DosyaId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_524862_value", "dosyaId1"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusForm",
      "DosyaGoster",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "71920",
      null,
      null,
      "true",
      "800px",
      "70vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_309815_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "DosyaGoster",
      "DosyaId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_524862_value", "dosyaId2"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusForm",
      "DosyaGoster",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "190842",
      null,
      null,
      "true",
      "800px",
      "70vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_930625_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "DosyaGoster",
      "DosyaId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_524862_value", "dosyaAd3"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusForm",
      "DosyaGoster",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "323320",
      null,
      null,
      "true",
      "800px",
      "70vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_233334_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MasrafForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_524862_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MasrafForm",
      "EditId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MasrafForm",
      "UcusNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_510322_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.UcusFormComponent_233334_onClick1_,
      "UcusForm",
      "MasrafForm",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "228696",
      null,
      null,
      "False",
      "800px",
      "70vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  UcusFormComponent_233334_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_233334_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafTmpToplamGuncelle = result?.data.masrafTmpToplamGuncelle;
    stateVars.MasrafTmpListe = result?.data.masrafTmpListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_233334_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_233334_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_524862 =
      stateVars.MasrafTmpListe ?? this.state.MasrafTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_452466_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "ucusform_524862_value", "id"),
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
      EditId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_808539_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "788e38f8_77b6_a59c_622a_f1890c9652e1_confirmation",
        this.defaultML,
        "Silmek istediğinize emin misiniz?"
      ),
      "poppins",
      "Uyarı",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "UcusForm/UcusFormComponent_452466_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.MasrafTmpSil = result?.data.masrafTmpSil;
      stateVars.MasrafTmpToplamGuncelle = result?.data.masrafTmpToplamGuncelle;
      stateVars.MasrafTmpListe = result?.data.masrafTmpListe;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.UcusFormComponent_452466_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_452466_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_524862 =
      stateVars.MasrafTmpListe ?? this.state.MasrafTmpListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusFormComponent_631587_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "ucusform_755702_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Mesaj giriniz...",
      formName: "ucusform_755702_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      IslemRUMB_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_25952_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
      Metin_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucusform_755702_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_631587_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaEkle = result?.data.yazismaEkle;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_631587_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_631587_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.YazismaEkle),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("HATA", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "78493",
      null,
      null,
      "true",
      "500px",
      "250px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UcusFormComponent_631587_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusId ?? this.props.screenInputs.ucusid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusForm/UcusFormComponent_631587_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaGetir = result?.data.yazismaGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusFormComponent_631587_onClick_else11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusFormComponent_631587_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucusform_755702_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  UcusFormComponent_631587_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(this, this.state.YazismaEkle),
        ""
      )
    ) {
      isErrorOccurred = await this.UcusFormComponent_631587_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.UcusFormComponent_631587_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [352231] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UcusFormPageInit();
    }
    if (diId == 166670) {
      isErrorOccurred = await this.UcusFormComponent_162835_onClick2_();
      if (isErrorOccurred) return true;
    } else if (diId == 909141) {
      isErrorOccurred = await this.UcusFormComponent_162835_onClick3_();
      if (isErrorOccurred) return true;
    } else if (diId == 817067) {
      isErrorOccurred = await this.UcusFormComponent_162835_onClick_if31_();
      if (isErrorOccurred) return true;
    } else if (diId == 608600) {
      isErrorOccurred = await this.UcusFormComponent_796340_onClick2_();
      if (isErrorOccurred) return true;
    } else if (diId == 313635) {
      isErrorOccurred = await this.UcusFormComponent_796340_onClick3_();
      if (isErrorOccurred) return true;
    } else if (diId == 817067) {
      isErrorOccurred = await this.UcusFormComponent_796340_onClick_if31_();
      if (isErrorOccurred) return true;
    } else if (diId == 139274) {
      isErrorOccurred =
        await this.UcusFormComponent_825552_onPressEnter_if11_();
      if (isErrorOccurred) return true;
    } else if (diId == 48533) {
      isErrorOccurred = await this.UcusFormComponent_825552_onPressEnter4_();
      if (isErrorOccurred) return true;
    } else if (diId == 595964) {
      isErrorOccurred = await this.UcusFormComponent_641052_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 833334) {
      isErrorOccurred = await this.UcusFormComponent_127384_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 187396) {
      isErrorOccurred = await this.UcusFormComponent_629348_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 228696) {
      isErrorOccurred = await this.UcusFormComponent_233334_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
